import { Button } from "common/components/ui/Button";

import PostPreview from "./PostPreview";
import PostStats from "./PostStats";

import type { LinkedInPost, PostStatus } from "../../../../../types";

interface PostDetailsProps {
  postStatus: PostStatus;
  linkedInPost: LinkedInPost;
  resetPostUrl: () => void;
  updatePostStatus: (status: keyof PostStatus, checked: boolean) => void;
  isLoading: boolean;
}

export default function PostDetails({
  postStatus,
  linkedInPost,
  resetPostUrl,
  updatePostStatus,
  isLoading,
}: PostDetailsProps) {
  const { likes, comments, shares } = linkedInPost ?? {};

  return (
    <article className="mx-auto flex w-full max-w-[1088px] flex-col gap-4 lg:flex-row lg:items-start lg:gap-8 lg:mt-4">
      <PostPreview post={linkedInPost} isLoading={isLoading} />

      <div className="flex flex-1 flex-col gap-4">
        <PostStats
          interactions={{ likes, comments, shares }}
          isLoading={isLoading}
          postStatus={postStatus}
          updatePostStatus={updatePostStatus}
        />

        <Button
          size="lg"
          variant="secondary-black"
          onClick={resetPostUrl}
          className="ml-auto"
        >
          Change post
        </Button>
      </div>
    </article>
  );
}
